export enum IThemeMode {
  DEFAULT = "DEFAULT",
}
